import React from "react";
import { IoCalendarClearOutline } from "react-icons/io5";

const GraphsWrapper = ({
  question,
  className = '',
  loading = false,
  showThisYear = false,
  childrenClassName = '',
  children,
}) => {
  return (
    <div
      className={`${className} rounded-xl p-4 flex flex-col bg-white w-full h-full ${loading ? 'animate-pulse' : ''}`}
    >
      {question ? (
        <span className="flex flex-row gap-1 mt-2 text-lg font-semibold justify-between">
          {question?.question_text}
          {showThisYear && <span className="text-sm text-gray-500 border border-gray-400 p-[6px] rounded-md flex flex-row gap-1 items-center"> <IoCalendarClearOutline size={16} /> This Year</span>}
        </span>
      ) : (
        <div className="animate-pulse">
          <div className="h-4 bg-lightGrey rounded w-3/4 mb-2" />
        </div>
      )}
      <div className={`${childrenClassName} flex-1 flex justify-center items-center relative`}>
        {children}
      </div>
    </div>
  );
};

export default GraphsWrapper;
